import { render, staticRenderFns } from "./PallutInfoCell.vue?vue&type=template&id=1b44e28f"
import script from "./PallutInfoCell.vue?vue&type=script&lang=js"
export * from "./PallutInfoCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports